// extracted by mini-css-extract-plugin
export var priceBox = "price-module--priceBox--jNbgP";
export var priceProductName = "price-module--priceProductName--VOyU9";
export var normalText = "price-module--normalText--Vsz6N";
export var quantityText = "price-module--quantityText--Spmdp";
export var priceText = "price-module--priceText--sh1P7";
export var priceOffText = "price-module--priceOffText--RbL5e";
export var quantityButton = "price-module--quantityButton--1DO6P";